import { NexaBlack } from '@/styles/fonts'
import Footer from './footer'

type MoreMenuSectionItem = {
    href: string
    label: string
}

type MoreMenuSection = {
    header: string
    items: MoreMenuSectionItem[]
}

type MoreMenuProps = {
    data: MoreMenuSection[]
}

function MoreMenu({ data }: MoreMenuProps) {
    return (
        <div className="flex h-full w-full flex-col">
            <div className="flex w-full flex-1 flex-row gap-8 has-[a:hover]:[&_a:not(:hover)]:opacity-60">
                {data.map((section) => (
                    <div key={section.header} className="flex flex-col pt-[22px] pr-6 pb-6 pl-10">
                        <h2 className={`text-[28px] font-bold text-white ${NexaBlack.className}`}>{section.header}</h2>
                        <div className="mt-[14px] -mr-5 mb-[14px] w-[calc(100%+35px)] border-[0.5px] border-t border-white opacity-30" />
                        <div className="grid grid-flow-col grid-rows-5 gap-x-8 ">
                            {section.items.map((item) => (
                                <a
                                    key={item.href}
                                    href={item.href}
                                    className="w-full py-2 text-left text-[15px] font-semibold text-white no-underline transition-opacity duration-500"
                                >
                                    {item.label}
                                </a>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <div className="mt-auto w-full">
                <Footer />
            </div>
        </div>
    )
}
export default MoreMenu
